import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { createTheme } from '@material-ui/core/styles';
import Navigation from './Navigation';
import { Container } from '@material-ui/core';


const theme = createTheme({
  palette: {
    type: 'dark',
  },
});


function Layout(props: any) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ display: 'flex' }}>
        <Navigation />
        <main style={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}>
          <Container className="container" style={{maxWidth: '100%'}}>
            {props.children}
          </Container>
        </main>
      </div>
    </ThemeProvider>
  )
}

export default Layout;
